<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<mat-drawer-container class="nv-hig playtest-home">
    <mat-drawer #sidenav autoFocus="false" class="main-sidebar-drawer">
        <div>
            @for (item of sidebarButtons; track item) {
                <button
                    class="nv-item-button-container complex-button font-body2"
                    mat-button
                    (click)="onClickMenuOption(item.action)"
                    tabIndex="0"
                >
                    <div class="nv-item-button-content">
                        <div class="nv-item-icon">
                            <mat-icon [svgIcon]="item.icon"></mat-icon>
                        </div>
                        <div class="font-body2">
                            {{ item.title }}
                        </div>
                    </div>
                </button>
            }
        </div>
    </mat-drawer>

    <mat-drawer-content class="main-sidebar-content">
        @if (menuOption === PlaytestMenu.settings) {
            <nv-settings></nv-settings>
        }
        @if (menuOption === PlaytestMenu.playtest || menuOption === PlaytestMenu.manageInvite) {
            <nv-sessions></nv-sessions>
        }
    </mat-drawer-content>
</mat-drawer-container>
